// extracted by mini-css-extract-plugin
export default {"body":"tokens_body__61uN1","strong":"tokens_strong__RjjMl","created-token":"tokens_created-token__9DZ8A"};